/**
 * API工具方法
 */
define(['base64'], function(base64) {
  const _jsAsynCall = window.external && window.external.jsAsynCall;
  const _cefQuery = window.cefQuery;
  const _isWpsEnv = _jsAsynCall || _cefQuery;

  const isWpsEnv = function() {
    return _isWpsEnv;
  };

  const executeInTestEnv = function(func) {
    if (!_isWpsEnv) {
      func();
    }
  };

  /**
   * 调用客户端API
   * @param {string} methodName 调用方法名称
   * @param {object} args 调用传入参数
   * @param {Function} callback 回调函数
   */
  const executeApi = function(methodName, args, callback) {
    if (!_isWpsEnv) {
      // TODO
      return null;
    }

    let invokeParams = {
      method: methodName,
      params: args
    };
    if (callback) {
      let callbackName = methodName + '_async_callback_' + setTimeout(_.noop, 0);
      window[callbackName] = function(res) {
        delete window[callbackName];
        callback(JSON.parse(base64.decode(res)));
      };
      invokeParams['callback'] = callbackName;
    }
    let jsonIn = base64.encode(JSON.stringify(invokeParams));
    console.log(JSON.stringify(invokeParams) + '==== base64 ====' + jsonIn);
    if (_cefQuery) {
      _cefQuery({
        request: `jsAsynCall("${jsonIn}")`,
        persistent: false
      });
    } else {
      _jsAsynCall(jsonIn);
    }
  };

  /**
   * 调用客户端API
   * @param {string} methodName 调用方法名称
   * @param {object} args 调用传入参数
   * @param {Function<object => object>} resultFilter 结果过滤函数, 可空
   */
  const asyncExecuteApi = function(methodName, args, resultFilter) {
    let dfd = $.Deferred();
    executeApi(methodName, args, (res) => {
      if (res.callstatus === 'ok') {
        dfd.resolve(resultFilter ? resultFilter(res.result) : res.result);
      } else {
        dfd.reject(res.errormsg);
      }
    });
    if (!_isWpsEnv) {
      // TODO
      return dfd.resolve();
    }
    return dfd.promise();
  };

  return {
    isWpsEnv,
    executeInTestEnv,
    executeApi,
    asyncExecuteApi
  };
});



/** WEBPACK FOOTER **
 ** ./src/scripts/apiv2/apiUtil.js
 **/